import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const AssetAllocation = lazy(() => import("@/pages/AssetAllocation/AssetAllocation"));
const AllocationGroups = lazy(() => import("@/pages/AssetAllocation/subs/AllocationGroups"));
const AllocationTypes = lazy(() => import("@/pages/AssetAllocation/subs/AllocationTypes"));
const RegisterRoute = lazy(() => import("@/pages/AssetAllocation/subs/RegisterRoute"));

const AssetAllocationRoute: RouteConfig = {
    path: "/asset-allocation",
    element: <AssetAllocation />,
    pageName: "Asset Allocation",
    sidebar: {
        show: true,
        icon: "/assets/media/allocation.svg",
    },
    permission: ["AssetAllocationView"],
    children: {
        GROUPS: {
            path: "",
            element: <AllocationGroups />,
        },
        TYPES: {
            path: ":groupId/types",
            element: <AllocationTypes />,
        },
        ITEMS: {
            path: ":groupId/types/:typeId/items",
            element: <RegisterRoute />,
        }
    }
};

export default AssetAllocationRoute;